import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./BooleanInput.scss";

function BooleanInput({
  id,
  label,
  value,
  onChange,
  trueLabel = "\u00A0\u00A0\u00A0Yes\u00A0\u00A0\u00A0",
  falseLabel = "\u00A0\u00A0\u00A0No\u00A0\u00A0\u00A0",
  unitLabel = "",
}) {
  const trueChecked = value === true;

  return (
    <div className="BooleanInput form-group form-row">
      <label htmlFor={id} className="col-6 col-form-label">
        {label}
      </label>
      <div className="col-6">
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          <label className={classNames("btn", "btn-light", { active: trueChecked })}>
            <input
              type="radio"
              name={id}
              id={`${id}${trueLabel}`}
              checked={trueChecked}
              onChange={() => {
                onChange(id, true);
              }}
            />
            {trueLabel}
          </label>
          <label className={classNames("btn", "btn-light", { active: !trueChecked })}>
            <input
              type="radio"
              name={id}
              id={`${id}${falseLabel}`}
              checked={!trueChecked}
              onChange={() => {
                onChange(id, false);
              }}
            />
            {falseLabel}
          </label>
        </div>
        <label htmlFor={id} className="col-form-label">
          {unitLabel}
        </label>
      </div>
    </div>
  );
}

BooleanInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  trueLabel: PropTypes.string,
  falseLabel: PropTypes.string,
  unitLabel: PropTypes.string,
};

export default BooleanInput;
